import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import ContextMenuItem, { ContextMenuItemData } from './ContextMenuItem';

interface Props {
  items: ContextMenuItemData[];
}

const ContextMenu: FC<Props> = ({ items }) => {
  return (
    <Box borderRadius="6px" overflow="hidden">
      {items.map((item, index) => (
        <ContextMenuItem key={index} {...item} />
      ))}
    </Box>
  );
};

export default ContextMenu;
